module.exports = __webpack_public_path__ + "static/media/dark2Single.d1963bc6.JPG";